import * as React from 'react';
import { Link } from 'react-router-dom';
import MetaTags from 'react-meta-tags';

const NotFound = (props) => { 
    return (
        <div className="main">
            <MetaTags>
                <title>{`Page not found - LoudUp`}</title>
                {/*test if we can render this component if the API/DB is down, if so, we don't want to send a noindex. we should have a separate error page for these cases*/}
                {/*<meta name="robots" content="noindex" /> */}
            </MetaTags> 
            <div className="container">
                <div className="block-inner">
                    <div className="row">
                        <div className="col-sm-8 col-sm-push-2">
                            <div className="errorbox">
                                <svg className="icon icn-error transition">
                                    <use xlinkHref="#icn-error" />
                                </svg>
                                <h2>404 error - Page not found</h2>
                                <p>Sorry, we cannot find the page you are looking for. 
                                <br />
                                <br />
                                Please try searching by clicking on the search icon above or <Link to="/">click here</Link> to return to the homepage or <Link to="/Contact">contact us</Link> to report the link as broken.</p>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>

    );
};

export default NotFound;